import middleware from "../../../shared/middleware";
import { setLocalStorage } from "../../../shared/utils/localStorage";
import constants from "../../../shared/constants";

const { retrieveAvsItems } = middleware;
const { LAST_TRENDING_UPCOMING_FETCH } = constants;

// Action Types
export const LOAD_FEED = "LOAD_FEED";
export const PAGE_COMPONENTS = "PAGE_COMPONENTS";
export const SWIMLANE_ITEMS = "SWIMLANE_ITEMS";
export const SET_TRENDING_FEED = "SET_TRENDING_FEED";

// Action Methods
const loadPageComponentSuccess = (components) => {
  return {
    type: PAGE_COMPONENTS,
    components,
  };
};

const loadPageComponentFailure = () => {
  return { type: PAGE_COMPONENTS, components: [] };
};

export const getPageComponents = (appProvider, pageUri, cancelTokenSource = null) => {
  return async (dispatch) => {
    try {
      const pageComponents = await retrieveAvsItems(appProvider, pageUri, false, cancelTokenSource);
      if (pageComponents) {
        dispatch(loadPageComponentSuccess(pageComponents.containers));
      }
    } catch (error) {
      dispatch(loadPageComponentFailure());
    }
  };
};

const setTrendingFeedSuccess = (trendingFeed) => ({
  type: SET_TRENDING_FEED,
  trendingFeed,
});

export const setTrendingFeed = (appProvider, trendingRoute, cancelTokenSource) => {
  return async (dispatch) => {
    try {
      const trendingFeed = await retrieveAvsItems(appProvider, trendingRoute, false, cancelTokenSource);
      if (trendingFeed?.containers?.length) {
        setLocalStorage(LAST_TRENDING_UPCOMING_FETCH, Date.now());
        dispatch(setTrendingFeedSuccess(trendingFeed.containers));
      }
    } catch (error) {
      console.error("Error fetching trending items:", error);
    }
  };
};
